/* eslint-disable no-undef */
/* eslint-disable @utiljs/utiljs/no-same-function */
/* eslint-disable no-unused-vars */
/* eslint-disable @utiljs/utiljs/cookie-cookie-limit */
/**
 * 中转页面
 * 1. 不使用utiljs提供的功能
 * a. utiljs库引入了无用代码
 * b. utiljs方法不满足当前页面需求
 */
import axios from 'axios';
// import VConsole from 'vconsole';

// const vConsole = new VConsole(); // eslint-disable-line

(function () {
    // 兜底链接"外卖分时段会场"页面，目前所有高达页面渲染接口访问峰值QPS 6000
    const iPage = 'https://market.waimai.meituan.com/gd/wm/3mPRWY?el_biz=waimai&el_page=gundam.loader&gundam_id=3mPRWY&activity_id=333466&tenant=gundam';
    let reqFlag = false;

    const setCookie = (cookieName, cookieValue) => {
        let domain = '.meituan.com';
        if (window.location.host.indexOf('sankuai') > -1) {
            domain = '.sankuai.com';
        }
        window.document.cookie = `${cookieName}=${encodeURIComponent(
            cookieValue || '',
        )};domain=${domain};path=/`;
    };
    const getUrlParam = (name, url) => {
        url = url ? String(url) : window.location.href;
        const results = new RegExp(`[\\?&]${String(name)}=([^&#]*)`).exec(url);

        if (!results) {
            return '';
        }

        return results[1] || '';
    };

    // 小程序环境将所有url上的参数除了click_cps_url之外都拼接上
    const obtainSearchParamObject = () => {
        const searchParams = window.location.search.replace('?','').split('&').filter(function(item){ return !!item }).reduce(function(pre,item){ var arr = item.split('='); if(arr.length=== 2){pre[arr[0]] = arr[1]} return pre},{});
        delete searchParams.click_cps_url;
        if (isWXApplet() && !searchParams.ctype) { // 微信小程序才增加 ctype
            searchParams.ctype = 'mt_mp';
        }
        return Object.keys(searchParams).map((key) => {
            return `&${key}=${searchParams[key]}`;
        }).join('');
    };

    const paramMerge = (url='') => {
        const preSearchParams = window.location.search.replace('?','').split('&').filter(function(item){ return !!item }).reduce(function(pre,item){ var arr = item.split('='); if(arr.length=== 2){pre[arr[0]] = arr[1]} return pre},{});
        const postSearchParams = url.split('?')[1].split('&').filter(function(item){ return !!item }).reduce(function(pre,item){ var arr = item.split('='); if(arr.length=== 2){pre[arr[0]] = arr[1]} return pre},{});
        const newParams = {
            ...preSearchParams,
            ...postSearchParams,
        }
        return Object.keys(newParams).map((key) => {
            return `&${key}=${newParams[key]}`;
        }).join('');
    };

    function addError(errName, msg, tags) {
        window.Owl && window.Owl.addError({
            name: errName,
            msg,
        }, {
            level: 'warn',
            category: 'ajaxError',
            tags,
        });
    }

    function isWXApplet() {
        const ua = window.navigator.userAgent.toLowerCase() || '';
        if (window.__wxjs_environment === 'miniprogram' || ua.indexOf('miniprogram') > -1) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * 是否是safari浏览器
     */
    // function isSafari() {
    //     return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    // }
    /**
     *
     * 是否是 美团APP
     */
    function isMeiTuanAPP() {
        if (window.KNB) {
            let { isTitans } = window.KNB.env;
            if (isTitans) {
                return new Promise((resolve, reject) => {
                    window.KNB.ready(() => {
                        KNB.getAppInfo({
                            success: function (data) {
                                // ios线上：10110， ios测试包：10111， 安卓线上：10120， 安卓线下：10121
                                if (data.appid === '10110' || data.appid === '10111' || data.appid === '10120' || data.appid === '10121') {
                                    resolve(true);
                                } else {
                                    resolve(false);
                                }
                            },
                            fail: function (err) {
                                console.log('err:::', err);
                                resolve(false);
                            },
                        });
                    });
                });
            } else {
                return Promise.resolve(false);
            }
        } else {
            return Promise.resolve(false);
        }
    }

    /**
     *
     * 是否是 外卖APP
     */
    function isMeiWmAPP() {
        if (window.KNB) {
            let { isTitans } = window.KNB.env;
            if (isTitans) {
                return new Promise((resolve, reject) => {
                    window.KNB.ready(() => {
                        KNB.getAppInfo({
                            success: function (data) {
                                // ios线上：10310， ios测试包：10311， 安卓线上：10120， 安卓线下：10321
                                if (data.appid === '10310' || data.appid === '10311' || data.appid === '10320' || data.appid === '10321') {
                                    resolve(true);
                                } else {
                                    resolve(false);
                                }
                            },
                            fail: function (err) {
                                console.log('err:::', err);
                                resolve(false);
                            },
                        });
                    });
                });
            } else {
                return Promise.resolve(false);
            }
        } else {
            return Promise.resolve(false);
        }
    }

    /**
     * https://km.sankuai.com/page/107501511
     * 百度小程序
     */
    function isBaiduApplet() {
        return window.navigator && window.navigator.userAgent.toLowerCase().includes('baiduboxapp');
    }

    /**
     * 头条或抖音小程序
     */
    function isTouOrDouApplet() {
        return window.navigator && window.navigator.userAgent.toLowerCase().includes('toutiaomicroapp');
    }

    /**
     * 获取网盟分销click页面的url地址
     */
    function getWmFxClickUrl({p, t ,c} = {}) {
        let ret = '';
        try {
            if (p && t && c) {
                const { origin, pathname } = window.location;
                ret = `${origin}${pathname}?p=${p}&t=${t}&c=${c}`;
            } else {
                ret = '';
            }
        } catch (e) {
            ret = '';
        }
        return ret;
    }

    /**
     *
     * 是否是 微信小程序
     */

    function req(data) {
        if (reqFlag) {
            return;
        }
        reqFlag = true;
        axios
            .post('/cps/clickReferralLink', data)
            .then(res => res.data)
            .then(async (res) => {
                if ((res.code === 0 || res.code === '0') && res.data) {
                    setCookie('unpl', res.data.unpl || '');
                    const wmFxClickUrl = getWmFxClickUrl(data);
                    setCookie('wm_fx_click_url', wmFxClickUrl); // 网盟分销ClickUrl
                    let isMeiTuanApp = await isMeiTuanAPP();
                    let isMeiWmApp = await isMeiWmAPP();
                    // 非 美团APP，非外卖APP，非 微信小程序，非 百度小程序，非 抖音小程序 => 加上click_cps_url, 为了唤起美团APP/外卖APP，先跳转click链接
                    if (!isMeiTuanApp && !isMeiWmApp && !isWXApplet() && !isBaiduApplet() && !isTouOrDouApplet()) {
                        res.data.landingPageUrl = res.data.landingPageUrl.indexOf('?') > -1 ? `${res.data.landingPageUrl}&click_cps_url=${encodeURIComponent(window.location.href)}` : `${res.data.landingPageUrl}?click_cps_url=${encodeURIComponent(window.location.href)}`;
                    }
                    // 在 微信小程序, 抖音小程序,  需要将除click_cps_url之外的参数都加上, 
                    if (isWXApplet() || isTouOrDouApplet()) {
                        const attachParamString = obtainSearchParamObject(); // 注意 ctype=mt_mp
                        res.data.landingPageUrl = res.data.landingPageUrl.indexOf('?') > -1 ? `${res.data.landingPageUrl}${attachParamString}` : `${res.data.landingPageUrl}?${attachParamString}`;
                    } else if (res.data.landingPageUrl.indexOf('_mtcq=0') !== -1) {
                        // 非小程序环境,如果参数中加_mtcq=0,都将当前url上的参数拼接上去； 外卖APP，解决https://km.sankuai.com/page/1320325554
                        const newSearchUrl = paramMerge(res.data.landingPageUrl)
                        res.data.landingPageUrl = `${res.data.landingPageUrl.split('?')[0]}?${newSearchUrl}`;
                    }

                    // 如果在团app、外卖app内，knb直接设置到app cookie中
                    // 目前通过knb写入方式有问题，先暂停，等经纬协商好再继续这块
                    if (window.KNB) {
                        // knb ready有兼容性问题，小程序里无执行，无返回，但是能获取到函数，因此uaInfo不能放在ready中
                        const {
                            appName,
                        } = window.KNB.uaInfo();
                        console.log('appName', appName);
                        // 美团外卖：ios内测包 meituanwaimai-c/com.meituan.itogo.ep；ios线上 meituanwaimai-c/com.meituan.itakeaway；安卓线上/内测 waimai/com.sankuai.meituan.takeoutnew
                        if (appName === 'meituan' || appName === 'meituanwaimai-c/com.meituan.itogo.ep' || appName === 'meituanwaimai-c/com.meituan.itakeaway' || appName === 'waimai/com.sankuai.meituan.takeoutnew') {
                            // 种cookie到app
                            window.KNB.ready(() => {
                                window.KNB.use('waimai.setUnpl', {
                                    unpl: res.data.unpl || '',
                                });
                                window.KNB.setStorage({
                                    key: 'unpl',
                                    value: res.data.unpl || '', // 数据值，String类型
                                    level: 1, // 存储级别，Interger类型，0 - 内存【默认】，1 - 设备，2 - 云端【11】
                                    success: () => {
                                        window.location.replace(res.data.landingPageUrl);
                                    },
                                    fail: (error) => {
                                        // report error
                                        addError(`${appName === 'meituan' ? '美团' : '外卖'}容器设置unpl异常`, error.msg, error);
                                        window.location.replace(res.data.landingPageUrl);
                                    },
                                });
                            });
                        } else {
                            window.location.replace(res.data.landingPageUrl);
                        }
                    } else {
                        console.log('not exist knb', res.data.landingPageUrl);
                        window.location.replace(res.data.landingPageUrl);
                    }
                } else {
                    addError(`后端异常code ${res.code}`, (res.msg || res.message), res);
                    window.location.href = iPage;
                }
            })
            .catch((err) => {
                console.log(err);
                addError(`接口异常 ${err.status || err.message}`, err.statusText || err.stack, err.data);
                window.location.href = iPage;
            });
    }

    const miniProgram = () => {
        const ua = window.navigator.userAgent.toLowerCase() || '';
        if (window.__wxjs_environment === 'miniprogram' || ua.indexOf('miniprogram') > -1) {
            const token = getUrlParam('token') || '';
            if (token) {
                setCookie('oops', token);
                console.log('token ok');
            }
        }
    };

    const getSessionId = (data) => {
        try {
            window.LXAnalytics('get', 'msid', (sessionId) => {
                data.sessionId = sessionId || '';
                console.log('lx ==>', sessionId);
                if (sessionId) {
                    req(data);
                } else {
                    addError('lx获取不到sessionId', `sessionId为 ${data.sessionId}`, null);
                    window.location.href = iPage;
                }
            });
        } catch (error) {
            // 兜底跳转，不再请求后端接口
            addError('获取sessionId报错', error.stack, null);
            window.location.href = iPage;
        }
    };

    function main() {
        // pv上报
        if (!window) {
            addError('初始化没有获取到window对象', '', null);
            return;
        }

        window.LXAnalytics('config', 'onWebviewAppearAutoPV', false);
        window.LXAnalytics('pageView', null, null, 'c_waimai_bqxk7hil');

        const data = {
            p: getUrlParam('p'),
            t: getUrlParam('t'),
            c: getUrlParam('c'),
            sessionId: '',
            referrer: window.document.referrer,
        };
        try {
            miniProgram();
        } catch (error) {
            addError(`token继承异常 ${error.message}`, error.stack, null);
        }
        const token = Rohr_Opt && typeof Rohr_Opt.reload === 'function' && Rohr_Opt.reload(window.location.href);
        data.fingerprintFromH5 = token || '';
        // 修改获取sessionId逻辑
        getSessionId(data);
    }

    main();
}());
